// extracted by mini-css-extract-plugin
module.exports = {"root":"PriceFilterPopup_root__NY4OB","label":"PriceFilterPopup_label__1OyUk","labelSelected":"PriceFilterPopup_labelSelected__2LvLT"};